@if(generalSettingsformService.generalSettingsFormReady() && settings) {
    <form autocomplete="off" [formGroup]="fiscalGroupForm" class="tw-contents">
        <div class="tw-flex tw-flex-col tw-gap-4">
            <app-card 
                [fullWidth]="false"
                [withCard]="true"
                [cardTitle]="'PRINTERS.GENERAL.OPTIONS' | translate"
            >
                <section class="tw-grid tw-grid-cols-1 tw-gap-3 tw-px-1 tw-items-center">
                    <mat-slide-toggle formControlName="ticket_change" class="tw-py-3">
                        <span class="tw-flex tw-ml-2">{{ 'PRINTERS.GENERAL.ENABLE_TICKET_CHANGE' | translate }}</span>
                    </mat-slide-toggle>
        
                    <mat-slide-toggle formControlName="print_notes" class="tw-py-3">
                        <span class="tw-flex tw-ml-2">{{ 'PRINTERS.GENERAL.PRINT_NOTES' | translate }}</span>
                    </mat-slide-toggle>
        
                    <mat-slide-toggle formControlName="print_description" class="tw-py-3">
                        <span class="tw-flex tw-ml-2">{{ 'PRINTERS.GENERAL.PRINT_DESCRIPTION' | translate }}</span>
                    </mat-slide-toggle>
        
                    <mat-slide-toggle formControlName="print_name" class="tw-py-3">
                        <span class="tw-flex tw-ml-2">{{ 'PRINTERS.GENERAL.PRINT_NAME' | translate }}</span>
                    </mat-slide-toggle>
        
                    <mat-slide-toggle formControlName="print_barcode_id" class="tw-py-3">
                        <span class="tw-flex tw-ml-2">{{ 'PRINTERS.GENERAL.PRINT_BARCODE_ID' | translate }}</span>
                    </mat-slide-toggle>
        
                    <mat-slide-toggle formControlName="print_sale_qr_code" class="tw-py-3">
                        <span class="tw-flex tw-ml-2">{{ 'PRINTERS.GENERAL.PRINT_SALE_QR_CODE' | translate }}</span>
                    </mat-slide-toggle>
        
                    <mat-slide-toggle formControlName="print_customer_details" class="tw-py-3">
                        <span class="tw-flex tw-ml-2">{{ 'PRINTERS.GENERAL.PRINT_CUSTOMER_DETAILS' | translate }}</span>
                    </mat-slide-toggle>
        
                    <mat-slide-toggle formControlName="print_seller" class="tw-py-3">
                        <span class="tw-flex tw-ml-2">{{ 'PRINTERS.GENERAL.PRINT_SELLER' | translate }}</span>
                    </mat-slide-toggle>
        
                    <mat-slide-toggle formControlName="print_daily_read_on_closing" class="tw-py-3">
                        <span class="tw-flex tw-ml-2">{{ 'PRINTERS.GENERAL.PRINT_DAILY_READ_ON_CLOSING' | translate }}</span>
                    </mat-slide-toggle>
        
                </section>
            </app-card>
        
            <app-card 
                [fullWidth]="false"
                [withCard]="true"
                [cardTitle]="'PRINTERS.GENERAL.GENERAL_SECTION' | translate"
            >
                <section class="tw-grid tw-grid-cols-1 tw-gap-3 tw-p-1">
            
                    <mat-form-field class="tw-col-span-12">
                        <mat-label translate>PRINTERS.GENERAL.DISPLAY_MESSAGE</mat-label>
                        <input matInput formControlName="display_message" appTrimInput>
                        <mat-hint [align]="'end'">{{generalSettingsformService.display_message.value.length || '0'}}
                            / {{generalSettingsformService.validators.displayMessageMaxLength}}</mat-hint>
                        @if(generalSettingsformService.display_message.hasError('maxlength')) {
                            <mat-error>{{'NG_MESSAGES.NAME_TOO_LONG' | translate}} (max. {{generalSettingsformService.validators.displayMessageMaxLength}})</mat-error>
                        }
                    </mat-form-field>
        
                    <mat-form-field class="tw-col-span-12">
                        <mat-label translate>PRINTERS.GENERAL.SELLER_PREFIX</mat-label>
                        <input matInput formControlName="seller_prefix" appTrimInput>
                        <mat-hint [align]="'end'">{{generalSettingsformService.seller_prefix.value.length || '0'}}
                            / {{generalSettingsformService.validators.sellerPrefixMaxLength}}</mat-hint>
                        @if(generalSettingsformService.seller_prefix.hasError('maxlength')) {
                            <mat-error>{{'NG_MESSAGES.NAME_TOO_LONG' | translate}} (max. {{generalSettingsformService.validators.sellerPrefixMaxLength}})</mat-error>
                        }
                    </mat-form-field>
        
                    <mat-form-field class="tw-col-span-12">
                        <mat-label translate>PRINTERS.GENERAL.TAIL</mat-label>
                        <textarea matInput cdkTextareaAutosize
                            cdkAutosizeMinRows="1"
                            cdkAutosizeMaxRows="5"
                            formControlName="tail">
                        </textarea>
                        <mat-hint [align]="'end'">{{generalSettingsformService.tail.value.length || '0'}}
                            / {{generalSettingsformService.validators.tailMaxLength}}</mat-hint>
                        @if(generalSettingsformService.tail.hasError('maxlength')) {
                            <mat-error>{{'NG_MESSAGES.NAME_TOO_LONG' | translate}} (max. {{generalSettingsformService.validators.tailMaxLength}})</mat-error>
                        }
                    </mat-form-field>
        
                    <mat-form-field class="tw-col-span-12">
                        <mat-label translate>PRINTERS.GENERAL.QR_MESSAGE</mat-label>
                        <textarea matInput cdkTextareaAutosize
                            cdkAutosizeMinRows="1"
                            cdkAutosizeMaxRows="5"
                            formControlName="qr_code_message">
                        </textarea>
                        <mat-hint [align]="'end'">{{generalSettingsformService.qr_code_message.value.length || '0'}}
                            / {{generalSettingsformService.validators.qrCodeMessageMaxLength}}</mat-hint>
                        @if(generalSettingsformService.qr_code_message.hasError('maxlength')) {
                            <mat-error>{{'NG_MESSAGES.NAME_TOO_LONG' | translate}} (max. {{generalSettingsformService.validators.qrCodeMessageMaxLength}})</mat-error>
                        }
                    </mat-form-field>
        
                    <mat-form-field class="tw-col-span-12">
                        <mat-label translate>PRINTERS.GENERAL.QR_URL</mat-label>
                        <textarea matInput cdkTextareaAutosize
                            cdkAutosizeMinRows="1"
                            cdkAutosizeMaxRows="5"
                            formControlName="qr_code_url">
                        </textarea>
                        <mat-hint [align]="'end'">{{generalSettingsformService.qr_code_url.value.length || '0'}}
                            / {{generalSettingsformService.validators.qrCodeUrlMaxLength}}</mat-hint>
                        @if(generalSettingsformService.qr_code_url.hasError('maxlength')) {
                            <mat-error>{{'NG_MESSAGES.NAME_TOO_LONG' | translate}} (max. {{generalSettingsformService.validators.qrCodeUrlMaxLength}})</mat-error>
                        }
                    </mat-form-field>
        
                </section>
            </app-card>
        </div>
    
        <app-card 
            [fullWidth]="false"
            [withCard]="true"
            [cardTitle]="'PRINTERS.GENERAL.HEADER_ROWS' | translate"
        >
            <section class="tw-grid tw-grid-cols-1 tw-gap-3 tw-px-1 tw-pb-1">
    
                <div class="tw-col-span-12">
                    <mat-slide-toggle formControlName="disable_header_configuration" class="tw-py-3">
                        <span class="tw-flex tw-ml-2">{{'PRINTERS.GENERAL.DISABLE_HEADER_CONFIGURATION' | translate}}</span>
                    </mat-slide-toggle>
                </div>
    
                @for (control of headerControls; track control; let i = $index) {
                    <mat-form-field class="tw-col-span-12">
                        <mat-label>{{ 'PRINTERS.GENERAL.ROW' | translate }} {{ i + 1 }}</mat-label>
                        <input matInput [formControl]="control" appTrimInput>
                        <mat-hint [align]="'end'">{{control.value.length || '0'}}
                            / {{generalSettingsformService.validators.headerRowMaxLength}}</mat-hint>
                        @if(control.hasError('maxlength')) {
                            <mat-error>{{'NG_MESSAGES.NAME_TOO_LONG' | translate}} (max. {{generalSettingsformService.validators.headerRowMaxLength}})</mat-error>
                        }
                    </mat-form-field>
                }
            </section>
        </app-card>
    </form>
}